import { api } from '@/modules/shared/lib/axios'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'

import type { IOrderFormJson } from '../types/order-form-json.type'

export interface IOrderFormSaveService {
  jsonOrderForm: IOrderFormJson
}

export const orderFormSaveService = async ({
  jsonOrderForm,
}: IOrderFormSaveService): Promise<ResponseAPI> => {
  const { data } = await api.post('salvarpedido', jsonOrderForm, {
    headers: {
      'Content-Type': 'application/json',
    },
  })

  return data
}
